import { FiltersDates, FiltersItems } from '../../models/Filters';

export interface CompletionCheckResponse {
  overall_completion: boolean;
  completion_percentage: number;
  completed_days: string[];
  incomplete_days: string[];
  start_date: string;
  end_date: string;
}

export interface WeeklyLogResponse {
  id: number;
  created: string;
  modified: string;
  new_sites_prospected: number;
  domain_exception_outreach: number;
  initial_outreach: number;
  initial_outreach_color: string | null;
  responses_received: number;
  approves: number;
  opens: number;
  closes: number;
  email_opened: number;
  unsubscribe: number;
  follow_ups: null | number;
  responses_sent: null | number;
  out_of_office: string;
  notes: null | string;
  status: string;
  day_name: string;
  date: string;
  user: number;
}

export interface WeeklyLogAveragesTotalRespInterface {
  new_sites_prospected: number;
  domain_exception_outreach: number;
  initial_outreach: number;
  responses_received: number;
  approves: number;
  opens: number;
  closes: number;
  email_opened: number;
  unsubscribe: number;
  follow_ups: number;
  responses_sent: number;
}

export interface WeeklyLogReqResponse {
  weekly_log_records: WeeklyLogResponse[];
  averages: WeeklyLogAveragesTotalRespInterface;
  totals: WeeklyLogAveragesTotalRespInterface;
}

export interface FiltersWeeklyLogsInterface {
  owner: FiltersItems;
  start_date: FiltersDates;
  end_date: FiltersDates;
}

export const filtersWeeklyLogsDefault: FiltersWeeklyLogsInterface = {
  owner: { id: 'owner', value: '' },
  start_date: { id: 'start_date', value: null },
  end_date: { id: 'end_date', value: null },
};

export interface FormWeeklyLogInterface {
  id: number;
  follow_ups: number | null;
  responses_sent: number | null;
  out_of_office: string | null;
  notes: string | null;
}

export interface WeeklyLogReqParams {
  owner: string | undefined;
  prev_week: number;
  start_date: string | undefined;
  end_date: string | undefined;
}

export const defaultWeeklyParams: WeeklyLogReqParams = {
  owner: undefined,
  prev_week: 0,
  start_date: undefined,
  end_date: undefined,
};

export const defaultWeeklyLogAverageTotal: WeeklyLogAveragesTotalRespInterface =
  {
    new_sites_prospected: 0,
    domain_exception_outreach: 0,
    initial_outreach: 0,
    responses_received: 0,
    approves: 0,
    opens: 0,
    closes: 0,
    email_opened: 0,
    unsubscribe: 0,
    follow_ups: 0,
    responses_sent: 0,
  };

export const outOfficeValuesArr = ['n/a', 'half'];
export const weekendDaysArr = ['saturday', 'sunday'];
